import { render, staticRenderFns } from "./empty-box.vue?vue&type=template&id=43b57764&scoped=true&"
import script from "./empty-box.vue?vue&type=script&lang=js&"
export * from "./empty-box.vue?vue&type=script&lang=js&"
import style0 from "./empty-box.vue?vue&type=style&index=0&id=43b57764&lang=scss&rel=stylesheet%2Fscss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "43b57764",
  null
  
)

export default component.exports